import React from 'react';
import PropTypes from 'prop-types';

import { Permissions } from '@src/global/permissions';

import { styled } from '@mui/material/styles';
import {
    DateInput,
    TextField,
    useRecordContext,
    Labeled,
} from 'react-admin';

import Moment from 'moment';

const StyledLabeled = styled(Labeled)({
    paddingTop: '6px',
    paddingBottom: 0,
});

const StyledTextField = styled(TextField)({
    top: '-8px',
    position: 'relative',
    fontSize: '1em',
});

const ExpirationDateInput = (props) => {
    const { source, resource } = props;
    const record = useRecordContext();

    let res = resource;
    let readOnly = true;
    if (res === 'attachments' || res === 'images') {
        res = 'images';
        readOnly = false;
    }

    if (Permissions(res, 'set_expiration') === false) {
        if (record && record.expired_at) {
            return (
                <StyledLabeled label="Expiration Date">
                    <StyledTextField
                        source={source.expiredAt}
                    />
                </StyledLabeled>
            );
        }

        return null;
    }

    return (
        <DateInput
            label="Expiration Date"
            source={source.expiredAt}
            inputProps={{ readOnly }}
            parse={(v) => Moment(v).toISOString()}
        />
    );
};

ExpirationDateInput.propTypes = {
    resource: PropTypes.string,
    source: PropTypes.object,
};

export default ExpirationDateInput;
